import {
  EventThemeConfig,
  ScreenElementFragment,
  StageEngagementFragment,
  FanEngagementFragment,
} from '@/generated/graphql';
import { EventScreenAction } from '@/providers/sharedActions';
import { Dispatch } from 'react';

export type ScreenDraftElement = Partial<ScreenElementFragment> & {
  id: string;
};

export type ThemeSavedConfig = Partial<
  Omit<EventThemeConfig, 'stageElements' | 'fanElements'>
> & {
  stageElements: Record<string, ScreenElementFragment>;
  fanElements: Record<string, ScreenElementFragment>;
};

export type ThemeDraftConfig = Partial<
  Omit<EventThemeConfig, 'stageElements' | 'fanElements'>
> & {
  stageElements?: Record<string, ScreenDraftElement>;
  fanElements?: Record<string, ScreenDraftElement>;
};

export enum EngagementMode {
  None = 'none',
  Guide = 'guide',
  Actual = 'actual',
}

export interface SharedScreenState {
  eventId: string;
  savedTheme: ThemeSavedConfig;
  draftTheme: ThemeDraftConfig;
  selectedElementId?: string | null;
  activeEngagement?: StageEngagementFragment | FanEngagementFragment | null;
  engagementMode: EngagementMode;
}

// Legacy type aliases for backward compatibility during migration
export type StageSavedConfig = ThemeSavedConfig;
export type StageDraftConfig = ThemeDraftConfig;
export type FanSavedConfig = ThemeSavedConfig;
export type FanDraftConfig = ThemeDraftConfig;
export type SharedStageState = SharedScreenState;
export type SharedFanState = SharedScreenState;

export type ScreenElementEditorProps = {
  elementId: string;
  dispatch: Dispatch<EventScreenAction>;
  state: SharedScreenState;
  enableLink?: boolean;
};

export type TextAlign = 'left' | 'center' | 'right';
